import styled from '@emotion/styled'

import { DefaultValue } from '../../enums/defaultValue'
import { Spacing } from '../../enums/spacing'
import { pxToNumber } from '../../utils/pxToNumber'
import { rwd } from '../../utils/rwd'

interface ContainerWrapperProps {
  fullWidth?: boolean
  fullHeight?: boolean
}

export const ContainerWrapper = styled.div<ContainerWrapperProps>`
  display: flex;
  flex-direction: column;
  width: calc(100% - ${pxToNumber(Spacing.S40) * 2}px);
  margin: 0 auto;

  ${({ fullWidth }) =>
    !fullWidth &&
    `
    max-width: ${DefaultValue.ContainerWidth};
  `};

  ${({ fullHeight }) =>
    fullHeight &&
    `
    height: 100%;
  `};

  ${rwd.equalOrLessThan('xlarge')} {
    width: calc(100% - ${pxToNumber(Spacing.S32) * 2}px);
  }

  ${rwd.equalOrLessThan('tablet')} {
    width: calc(100% - ${pxToNumber(Spacing.S16) * 2}px);
  }
`
